export var hasErrorDep = Symbol('hasError');
export var submittingDep = Symbol('submitting');
export var dirtyDep = Symbol('dirty');
